module.exports = {
        srcSet: "/_next/static/images/stability-640.52fefce7.webp"+" 640w"+","+"/_next/static/images/stability-828.72b42b27.webp"+" 828w"+","+"/_next/static/images/stability-950.afb3f932.webp"+" 950w",
        images: [{path: "/_next/static/images/stability-640.52fefce7.webp",width: 640,height: 763},{path: "/_next/static/images/stability-828.72b42b27.webp",width: 828,height: 987},{path: "/_next/static/images/stability-950.afb3f932.webp",width: 950,height: 1132}],
        src: "/_next/static/images/stability-950.afb3f932.webp",
        toString: function(){return "/_next/static/images/stability-950.afb3f932.webp"},
        
        width: 950,
        height: 1132
      }